export class Extra {
  _id: string;
  ean13: string;
  // dtcont: Date;
  dtcont: string;
  filename: string;
  descrizione: string;
  categoria: string;
  ordinamento: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Extra.ts